module.exports = __webpack_public_path__ + "img/home_background_img.e3ef10f8.png";